import React from "react";
import { useFetchChatList } from "../../hooks/useFetchData";
import MainLayout from "../../components/layouts/MainLayout";
import Breadcrumb from '../../components/shared/Breadcrumbs';

const ChatListPage = () => {
  const { data: chatlist, loading, error } = useFetchChatList(); 
  const backUrl = process.env.REACT_APP_API_URL;

  console.log(chatlist);
  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error loading jobs: {error.message}</p>;

  // const chat_room_url = '/chat/'
  const breadcrumbs = [
    { label: "Home", path: "/" },
    { label: "メッセージ一覧", path: "/chat-list" },
  ];

  return(
    <MainLayout>
      <Breadcrumb items={breadcrumbs} />
      <div className="chatlist">
        <h2>Message</h2>
      {chatlist.map((chat) => (
        <div>
        <a href={`/chat/${chat.chat_room_id}/${Math.min(chat.user1, chat.user2)}/${Math.max(chat.user1, chat.user2)}`} >
        <div className="chatlist__img">
          { chat.other_user.image ?(
          <img src={`${backUrl}/media/${chat.other_user.image}`} />
          ): chat.other_user.line_image&& chat.other_user.line_image !== "None" ?(
          <img src={`${chat.other_user.line_image}`} />
          ):(
            <img src="/media/none_user.svg" />
          )}
        </div>
        <div className="chatlist__cont">
          <h4>{chat.other_user.username}</h4>
          <div className="chatlist__cont-txt">
            <p>{chat.latest_message}</p>
          </div>
        </div>
        </a>
        <img className="chatlist__line" src='/media/line.svg' />
        </div>
        ))}
      </div>
    </MainLayout>
  )

}
export default ChatListPage